import React from 'react';
import './ConfirmModal.css';
import { FaExclamationTriangle, FaCheckCircle, FaInfoCircle } from 'react-icons/fa';

/**
 * Modal de confirmación personalizado con diseño y colores
 * @param {object} props
 * @param {boolean} props.isOpen - Si el modal está visible
 * @param {string} props.title - Título del modal
 * @param {string} props.message - Mensaje del modal
 * @param {string} props.type - Tipo: 'warning', 'success', 'info' (default: 'info')
 * @param {function} props.onConfirm - Callback al confirmar
 * @param {function} props.onCancel - Callback al cancelar
 * @param {string} props.confirmText - Texto del botón confirmar (default: 'Confirmar')
 * @param {string} props.cancelText - Texto del botón cancelar (default: 'Cancelar')
 * @param {boolean} props.showCancel - Si muestra el botón cancelar (default: true)
 */
const ConfirmModal = ({
    isOpen,
    title,
    message,
    type = 'info',
    onConfirm,
    onCancel,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    showCancel = true,
    confirmColor,
    cancelColor,
}) => {
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'warning':
                return <FaExclamationTriangle className="modal-icon warning-icon" />;
            case 'success':
                return <FaCheckCircle className="modal-icon success-icon" />;
            case 'info':
            default:
                return <FaInfoCircle className="modal-icon info-icon" />;
        }
    };

    const getModalClass = () => {
        return `confirm-modal-content ${type}-modal`;
    };

    return (
        <div className="confirm-modal-overlay" onClick={onCancel}>
            <div className={getModalClass()} onClick={(e) => e.stopPropagation()}>
                <div className="confirm-modal-header">
                    {getIcon()}
                    <h3 className="confirm-modal-title">{title}</h3>
                </div>
                <div className="confirm-modal-body">
                    <p className="confirm-modal-message">{message}</p>
                </div>
                <div className="confirm-modal-footer">
                    {showCancel && (
                        <button 
                            className="confirm-modal-btn cancel-btn" 
                            onClick={onCancel}
                            style={cancelColor ? { backgroundColor: cancelColor, color: 'white' } : {}}
                        >
                            {cancelText}
                        </button>
                    )}
                    <button 
                        className={`confirm-modal-btn confirm-btn ${type}-btn`} 
                        onClick={onConfirm}
                        style={confirmColor ? { backgroundColor: confirmColor } : {}}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
